import { makeStyles } from '@material-ui/core/styles';

export default function ProdutoCardCss() {
    return makeStyles((theme) => ({
        button: {
            height: '55px',
            borderRadius: '0 10px 10px 0',
        },
        cardPedido: {
            marginTop: '20px',
            marginBottom: '20px',
        },
        contentTop: {
            display: 'flex',
        },
        contentMiddle: {
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: '20px',
            marginBottom: '20px',
        },
        modalFooter: {
            padding: "20px",
        },
    }));
}
